import { createEvent } from 'effector';

export const changeStatusEv = createEvent();

export const changeCommentEv = createEvent();
